import { T } from 'gt-react';
import { useArOverPaymentRecommendations } from '@/api/rpc/hooks/accounts-receivable/useArOverPaymentRecommendations';
import { CollectionRecommendationCard } from './CollectionRecommendationCard';

interface Props {
  threadId: string;
  onDraftEmail: (seed: {
    initialPrompt: string;
    initialToRecipients?: string[];
  }) => void;
}

/**
 * Over-payment recommendation card — a thin binding of the shared
 * CollectionRecommendationCard to the over-payment recommendations hook.
 */
export function OverPaymentRecommendationCard({
  threadId,
  onDraftEmail,
}: Props) {
  const recommendations = useArOverPaymentRecommendations(threadId);

  return (
    <CollectionRecommendationCard
      onDraftEmail={onDraftEmail}
      emptyState={
        <T context="empty state, no over-payment recommendation yet">
          No recommendation yet. It generates automatically for new
          over-payments — use Regenerate if it hasn't appeared.
        </T>
      }
      {...recommendations}
    />
  );
}
